require('./feed-loader.scss');
var owlCarousel = require('src/interlock/ui/owl-carousel/owl-carousel');
var drawerScrollEngagement = require('src/interlock/no-ui/engagement-handler/scroll-engagement-handler/drawer-scroll-engagement-handler');
var $drawerList = $('[data-drawer-list]');
var ads = require('src/interlock/product/ads/index');
var drawerRemoveRenderContent = require('src/interlock/ui/drawer/drawer');
var deferUrlEntries = {};
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones.js');

function prepareDeferUrlEntries(component, storage) {
    var deferEntryId = component.data('cmsentry');
    var deferEntryUrl = component.data('url') || component.data('cmsfeed');
    var deferCmsFeedReqParams = component.data('r');

    if(deferCmsFeedReqParams && deferEntryUrl) {
        deferEntryUrl += '?' + deferCmsFeedReqParams;
    }

    if(deferEntryUrl) {
        if(storage[deferEntryUrl]) {
            storage[deferEntryUrl].push(deferEntryId);
        } else {
            storage[deferEntryUrl] = [deferEntryId];
        }
    }
}

$('[data-cmsfeed]').each(function(index, component) {
    var $deferComponent = $(component);

    if(!$deferComponent.data('scrolldefer')) {
        prepareDeferUrlEntries($deferComponent, deferUrlEntries);
    }
});

for(var k in deferUrlEntries) {
    var deferUrl = k + '&entry-id=' + deferUrlEntries[k].join(',');
    $.get(deferUrl)
        .then(function (data) {
            for (var entryId in data.htmls) {
                renderDeferHtml(entryId, data.htmls[entryId]);
            }

            renderDrawerHtml(data.drawerHtml);
            if (data.dataStorage && Object.keys(data.dataStorage).length > 0) {
                $.extend(window.EDMDataStorage, data.dataStorage);
            }
            ads.adManager.renderAds();
            appendFiles(data.files);
            // TODO: need to handle data.scripts injection.

            // debug code to log when a deferred feed is called.
            if (window.location.search.indexOf('debug=true') > -1) {
                window.console.log('POST-LOAD URL CALLED: ', deferUrl);
            }
        });
}

//WEB17-116 -- Please clean up this file if we go with this solution.
function renderDeferredModule() {
    var deferredModuleUrlEntry = {};
    var visibleQueue = [];


    $('[data-scrolldefer]').each(function(index, component) {

        var $w = $(window);
        var $e = $(component);
        var th = 0;
        var wt = $w.scrollTop(),
            wb = wt + $w.height(),
            et = $e.offset().top,
            eb = et + $e.height();
        if((eb >= wt - th && et <= wb + th) && !$e.attr('data-loaded')){
            $e.attr('data-loaded',true);
            visibleQueue.push($e);
        }

    });

    $.each(visibleQueue,function(index, component) {
        var $deferComponent = $(component);
        prepareDeferUrlEntries($deferComponent, deferredModuleUrlEntry);
    });

    for(var k in deferredModuleUrlEntry) {
        var deferUrl = k + '&entry-id=' + deferredModuleUrlEntry[k].join(',');
        var deferEntry;
        $.get(deferUrl)
            .then(function(data) {
                for(var entryId in data.htmls) {
                    renderDeferHtml(entryId, data.htmls[entryId]);
                }

                renderDrawerHtml(data.drawerHtml);
                if(data.dataStorage && Object.keys(data.dataStorage).length > 0) {
                    $.extend(window.EDMDataStorage, data.dataStorage);
                }
                ads.adManager.renderAds();
                appendFiles(data.files);
                // TODO: need to handle data.scripts injection.

                deferEntry = $('.'+entryId).children();
                deferEntry.removeClass('loading');
                // debug code to log when a deferred feed is called.
                if(window.location.search.indexOf('debug=true') > -1) {
                    window.console.log('POST-LOAD URL CALLED: ', deferUrl);
                }

            });
    }
}


function renderDeferHtml(entryId, html) {
    if($(html).hasClass('edm-entry')) {
        html = $(html)[0].innerHTML;
    }
    var $deferComponent = $('[data-cmsentry="'+entryId+'"]');
    $deferComponent.html(html);
    initDeferredOwlCarousel($deferComponent);
    $deferComponent.find('.punit').asyncGptTag({});
}

function renderDrawerHtml(html) {
    if(html) {
        var drawerId = $(html).attr('id');
        $drawerList.append(html);
        drawerRemoveRenderContent.init();
        drawerScrollEngagement.init();
        initDeferredOwlCarousel($('#' + drawerId));
    }
}

function appendFiles(files) {
    files.css.forEach(function(cssUrl) {
        loadCss(cssUrl);
    });
    files.js.forEach(function(jsUrl) {
        loadJs(jsUrl);
    });
}

function initDeferredOwlCarousel($content) {
    var deferredOwlCarousel = $content.find('.owl-carousel');
    if(deferredOwlCarousel.length > 0) {
        owlCarousel.init(deferredOwlCarousel);
    }
}

function loadJs(url) {
    $.getScript(url, function() {});
}

function loadCss(url) {
    var link = $('<link/>', {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });
    link.on('load', function () {
        eventToolbox.fireCustomEvent('defer-css-loaded', [ url ]);
    });
    link.appendTo('head');
}



$(window.document).on(REFRESH_ZONES.ENGAGEMENT, function(){
    renderDeferredModule();
});

module.exports = {
    renderDeferredModule: renderDeferredModule
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/defer/feed-loader.js
// module id = 96
// module chunks = 0 1 3 6 8 11 12 14